import { skipToken } from '@reduxjs/toolkit/query';
import WorkspaceInheritanceAPI from '../WorkspaceInheritance/WorkspaceInheritanceAPI';
import useMyWorkspace from './useMyWorkspace';
import type { TypedUseQuerySubscriptionOptions } from '@reduxjs/toolkit/query/react';

type Options = TypedUseQuerySubscriptionOptions;
function useMyWorkspacesChildren(options?: Options) {
  const { data: workspace } = useMyWorkspace();
  return WorkspaceInheritanceAPI.useGetChildrenQuery(
    workspace?.id ?? skipToken,
    options
  );
}

export default useMyWorkspacesChildren;
